import { useEffect, useState } from 'react';
import { DEFAULT_LOCALE } from 'localeConstants';
export const useLocale = (appLocale)=>{
    const [locale, setLocale] = useState();
    useEffect(()=>{
        const importLocale = async ()=>{
            const appLocaleArr = appLocale.split('-');
            if (appLocaleArr[1]) appLocaleArr[1] = appLocaleArr[1].toUpperCase();
            const localeName = appLocaleArr.join('');
            const localeModule = await import('react-day-picker/locale');
            const loc = localeModule[localeName] || localeModule[DEFAULT_LOCALE];
            setLocale(loc);
        };
        importLocale();
    }, [
        appLocale
    ]);
    return locale;
};
